// extracted by mini-css-extract-plugin
export default {"form":"CreateProjectForm_form__+oIS3","fields":"CreateProjectForm_fields__ALSL2"};